// /settings/profile — редактирование профиля.
// См. docs/ui-spec/settings.profile.{desktop,mobile}.md.
import { Button } from "@studyhub/ui/components/button";
import { toast } from "@studyhub/ui/toast";
import { IconLogout, IconUser } from "@tabler/icons-react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SettingsPageContainer, SettingsPageHeader } from "@/components/settings/page-header";
import { ProfileForm } from "@/components/settings/profile-form";
import { PagePendingFallback } from "@/components/shared/page-pending-fallback";
import { performSignOut } from "@/lib/logout";

export const Route = createFileRoute("/settings/profile")({
	component: ProfileRoute,
	pendingComponent: PagePendingFallback,
});

function ProfileRoute() {
	const { t } = useTranslation("settings");
	return (
		<SettingsPageContainer>
			<SettingsPageHeader title={t("profile.title")} icon={<IconUser stroke={1.75} />} />
			<ProfileForm />
			<ProfileLogoutSection />
		</SettingsPageContainer>
	);
}

// Кнопка выхода внизу профиля. На mobile аватар убран из шапки (в drawer он —
// прямая ссылка сюда), поэтому выход доступен только отсюда. На desktop дублирует
// пункт меню профиля — это ок, стандартное действие на странице аккаунта.
function ProfileLogoutSection() {
	const { t } = useTranslation("settings");
	const navigate = useNavigate();

	function onLogout() {
		// Полный выход: revoke сессии + bearer + очистка session-store, query-кэша
		// (in-memory + persist) и PowerSync — тот же путь, что в ProfileDropdown.
		void performSignOut().finally(() => {
			toast.success(t("logoutSuccess"));
			void navigate({ to: "/" });
		});
	}

	return (
		<div className="mt-8 flex justify-center border-t border-border px-4 pt-6 lg:justify-start lg:px-0">
			<Button
				type="button"
				variant="outline"
				className="w-full gap-2 text-destructive hover:text-destructive sm:w-auto"
				onClick={onLogout}
			>
				<IconLogout size={18} stroke={1.75} />
				{t("profileMenu.logout")}
			</Button>
		</div>
	);
}
